<template>
    <div class="tab-training">
        <Folder
            v-if="getInviteCourses && getInviteCourses.length"
            v-loading="invitesLoading"
            class="invite"
            title="Приглашения"
        >
            <div class="tab-training__invite-courses" v-for="invite in getInviteCourses" :key="invite.id">
                <div class="tab-training__invite-courses-header">
                    <h3 class="tab-training__invite-courses-header-title">Новое приглашение</h3>
                    <div class="tab-training__invite-courses-header-actions">
                        <div
                            class="tab-training__invite-courses-header-actions-action"
                            :class="{ opacity: !isMobile }"
                            @click="
                                updateInvites({
                                    id: invite.id,
                                    confirm: isMobile,
                                })
                            "
                        >
                            {{ isMobile ? 'Принять' : 'Отклонить' }}
                        </div>
                        <div
                            class="tab-training__invite-courses-header-actions-action"
                            :class="{ opacity: isMobile }"
                            @click="
                                updateInvites({
                                    id: invite.id,
                                    confirm: !isMobile,
                                })
                            "
                        >
                            {{ isMobile ? 'Отклонить' : 'Принять' }}
                        </div>
                    </div>
                </div>
                <div class="tab-training__invite-courses-body">
                    <div class="tab-training__invite-courses-body-img-wrapper">
                        <img
                            class="tab-training__invite-courses-body-img"
                            :src="(invite.cover && invite.cover.url) || require('../../../assets/images/no-pic.svg')"
                        />
                    </div>
                    <div class="tab-training__invite-courses-body-info">
                        <h3 class="tab-training__invite-courses-body-info-title">
                            {{ invite.name }}
                        </h3>
                        <div
                            v-html="invite.description"
                            class="tab-training__invite-courses-body-info-description"
                        ></div>
                    </div>
                </div>
            </div>
        </Folder>
        <div v-loading="coursesLoading">
            <Folder
                v-if="getCourses && getCourses.length"
                title="Обучение"
                actions
                class="folder"
                @active="tabIndex = 0"
                @finished="tabIndex = 1"
            >
                <EducationCourses :tabIndex="tabIndex" :items="getCourses || []" />
            </Folder>
            <EmptyTabsCard
                v-else
                :emptyImgLink="emptyImgLink"
                cardTitle="Обучение"
                toFullRouter="/education"
                emptyText="Еще нет курсов"
            />
        </div>

        <div v-loading="recomendationsLoading">
            <Folder
                v-if="getRecomendationCourses && getRecomendationCourses.length"
                title="Рекомендации"
                class="folder"
            >
                <EducationCourses :items="getRecomendationCourses || []" recomended />
            </Folder>
            <EmptyTabsCard
                v-else
                v-loading="recomendationsLoading"
                :emptyImgLink="emptyImgLinkRec"
                cardTitle="Рекомендации"
                toFullRouter="/education"
                emptyText="Мы пока не решили, <br> что вам порекомендовать"
                no-action
            />
        </div>
        <!-- <Folder class="folder" title="Рекомендовано">
            <RecommendedTraining
                :courses="recommendedCourses"
                :webinars="recommendedWebinars"
            />
        </Folder> -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Folder from '@/components/UI/Folder';
import EducationCourses from './tab-training/EducationCourses';
import EmptyTabsCard from '../../UI/EmptyTabsCard';

const eventsActions = [
    'loadCurrentCourses',
    'loadFinishedCourses',
    'loadRecomendationCourses',
    'loadInviteCourses',
    'refuseInvite',
    'confirmedInvite',
];

const eventsGetters = ['getCourses', 'getRecomendationCourses', 'getInviteCourses'];

const getters = ['isMobile'];

export default {
    name: 'TabTraining',
    components: {
        Folder,
        EducationCourses,
        EmptyTabsCard,
    },
    data: () => ({
        showInvites: false,
        tabIndex: 0,
        coursesLoading: true,
        recomendationsLoading: true,
        invitesLoading: true,
    }),
    async mounted() {
        await this.loadInviteCourses();
        this.invitesLoading = false;
        await this.loadFinishedCourses();
        await this.loadCurrentCourses();
        this.coursesLoading = false;
        await this.loadRecomendationCourses();
        this.recomendationsLoading = false;
    },
    computed: {
        ...mapGetters('events', eventsGetters),
        ...mapGetters(getters),
        emptyImgLink() {
            return require(`../../../assets/images/oops-rhino-painter.svg`);
        },
        emptyImgLinkRec() {
            return require(`../../../assets/images/oops-rhino.svg`);
        },
    },
    methods: {
        ...mapActions('events', eventsActions),
        toEducationList() {
            window.location = '/education';
        },
        async updateInvites(data) {
            if (data.confirm) {
                await this.confirmedInvite(data.id);
                this.invitesLoading = true;
                await this.loadInviteCourses();
                this.invitesLoading = false;
                this.coursesLoading = true;
                await this.loadCurrentCourses();
                this.coursesLoading = false;
            } else {
                await this.refuseInvite(data.id);
                this.invitesLoading = true;
                await this.loadInviteCourses();
                this.invitesLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.tab-training {
    .folder {
        margin-bottom: 1rem;
        border-radius: rem(10);
        @include on-mobile {
            margin-bottom: mrem(24);
        }

        &:last-of-type {
            @include on-mobile {
                margin-bottom: 0;
            }
        }
    }

    &__invite-courses {
        background-color: #ffffff;
        min-height: mrem(338);
        border-radius: mrem(10);
        margin-bottom: mrem(20);

        @include on-desktop {
            min-height: rem(214);
            border-radius: rem(10);
            margin-bottom: rem(32);
        }

        &-header {
            background: #68c87a;
            font-family: 'Open Sans';
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: mrem(20);
            height: mrem(80);
            margin-bottom: mrem(20);
            border-radius: mrem(10) mrem(10) 0 0;

            @include on-desktop {
                height: rem(50);
                margin-bottom: rem(20);
                padding: rem(13) rem(20);
                border-radius: rem(10) rem(10) 0 0;
            }

            &-title {
                margin: 0;
                font-style: normal;
                font-weight: 700;
                color: #ffffff;
                font-size: mrem(18);
                line-height: mrem(20);
                width: mrem(154);

                @include on-desktop {
                    width: inherit;
                    font-size: rem(18);
                    line-height: rem(20);
                }
            }

            &-actions {
                display: block;

                @include on-desktop {
                    display: flex;
                }

                &-action {
                    color: #ffffff;
                    font-style: normal;
                    font-weight: 700;
                    cursor: pointer;
                    font-size: mrem(14);
                    line-height: mrem(20);
                    text-align: right;

                    &:first-child {
                        margin-bottom: rem(22);
                    }

                    @include on-desktop {
                        text-align: left;
                        font-size: rem(14);
                        line-height: rem(20);
                        border-bottom: rem(1) solid #ffffff;

                        &:first-child {
                            margin-right: rem(10);
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }

        &-body {
            font-family: 'Circe Rounded';
            padding: mrem(0) mrem(20) mrem(20) mrem(20);
            @include on-desktop {
                display: flex;
                padding: rem(0) rem(20) rem(20) rem(20);
            }

            &-img {
                width: mrem(220);
                height: mrem(124);
                border-radius: mrem(10);
                margin-bottom: mrem(20);

                @include on-desktop {
                    width: rem(220);
                    height: rem(124);
                    max-width: none;
                    border-radius: rem(10);
                    margin-right: rem(20);
                    margin-bottom: 0;
                }

                &-wrapper {
                    display: flex;
                    justify-content: center;

                    @include on-desktop {
                        display: block;
                    }
                }
            }

            &-info {
                &-title {
                    margin: 0;
                    font-style: normal;
                    font-weight: 700;
                    color: #000000;
                    font-size: mrem(18);
                    line-height: mrem(22);
                    text-align: center;

                    @include on-desktop {
                        text-align: left;
                        font-size: rem(18);
                        line-height: rem(22);
                        margin-bottom: rem(8);
                    }
                }

                &-description {
                    color: #2a2626;
                    font-style: normal;
                    font-weight: 400;
                    font-size: mrem(16);
                    line-height: mrem(20);
                    text-align: center;

                    @include on-desktop {
                        text-align: left;
                        font-size: rem(16);
                        line-height: rem(20);
                    }
                }
            }
        }
    }

    &__empty-recomendations {
        font-family: 'Circe Rounded';
        cursor: pointer;
        height: mrem(184);
        background: #ffffff;
        padding: mrem(20);
        box-shadow: mrem(0) mrem(6) mrem(10) rgba(131, 134, 163, 0.12);
        border-radius: mrem(4);

        @include on-desktop {
            height: rem(168);
            padding: rem(30);
            box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);
            border-radius: rem(4);
        }

        &-title {
            margin: mrem(0) mrem(0) mrem(20) mrem(0);
            font-style: normal;
            font-size: mrem(24);
            line-height: mrem(32);
            font-weight: 700;
            color: #2a2626;

            @include on-desktop {
                margin: rem(0) rem(0) rem(20) rem(0);
                font-size: rem(24);
                line-height: rem(32);
            }
        }

        &-description {
            font-style: normal;
            font-weight: 350;
            color: #2a2626;
            font-size: mrem(16);
            line-height: mrem(20);
            margin-bottom: mrem(16);

            @include on-desktop {
                font-size: rem(16);
                line-height: rem(20);
                margin-bottom: rem(16);
            }
        }

        &-more {
            cursor: pointer;
            // text-decoration: underline;
            font-style: normal;
            font-weight: 400;
            color: #4663ab;
            font-size: mrem(16);
            line-height: mrem(20);
            margin-bottom: mrem(6);
            width: mrem(254);
            border-bottom: mrem(1) solid #4663ab;

            @include on-desktop {
                font-size: rem(16);
                line-height: rem(20);
                margin-bottom: rem(0);
                width: rem(254);
                border-bottom: rem(1) solid #4663ab;
            }
        }
    }
}

.invite ::v-deep {
    background-color: #f8f8f8 !important;
    box-shadow: mrem(0) mrem(6) mrem(10) rgba(131, 134, 163, 0.12);

    @include on-desktop {
        box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);
    }
}

.opacity {
    opacity: 0.5;
}
</style>
